import gsap from 'gsap';
import WithPageTransition from 'utils/mixins/with-page-transition';
import ScrollService from 'utils/services/scroll-service';
import { inRange } from '@resn/gozer-math';

import getStore from 'core/store';
const store = getStore();

import './index.scss';
import { standardHeaderProps } from 'data/header-data';

const PageMixin = {
    ...WithPageTransition,

    options: {
        ...standardHeaderProps,
    },

    props: {
        x: 0,
        active: false,
        scrollLock: () => store.state.scrollLock,
        needsResize: () => store.state.needsResize,
    },

    async onBeforeSetup() {
        this.sections = [];
        this.tweens = {
            x: 0,
            y: 0,
        };
    },

    async onAfterSetup() {
        if (this.onBeforeEnterAnimation) this.onBeforeEnterAnimation();
    },

    onAssetsPreloaderComplete() {
        this.sections.forEach((section) => {
            if (section.preloadComplete) section.preloadComplete(this.assets);
        });
    },

    setHeaderProps() {
        const { bgAboveFold, bgColor, textColorAboveFold, textColorBelowFold } = this.options;

        store.state.header.bgAboveFold = bgAboveFold;
        store.state.header.bgColor = bgColor;
        store.state.header.textColorAboveFold = textColorAboveFold;
        store.state.header.textColorBelowFold = textColorBelowFold;
    },

    onActive() {
        this.setHeaderProps();

        store.state.scrollLock = false;
    },

    whileActive() {
        if (this.sections) {
            this.updateSections();
            // this.renderSections();
        }
    },

    updateSections() {
        this.sections.forEach((section) => {
            const { bounds, viewport } = section.props;
            const scroll = ScrollService.scroll;
            const intersecting = inRange(scroll, bounds.top - viewport.height + 1, bounds.bottom);
            const activeViewport = inRange(
                scroll,
                bounds.top - viewport.height * 0.5,
                bounds.bottom - viewport.height * 0.5,
            );

            section.props.intersecting = intersecting;
            section.props.activeViewport = activeViewport;
            // if (intersecting) console.log(`${section.options.id} intersecting: ${section.props.intersecting}`);
        });

        store.state.sectionsActive = this.sections
            .filter((section) => section.props.active)
            .map((section) => section.options.id);
    },

    renderSections() {
        this.sections.forEach((section) => {
            if (section.props.active) {
                if (section.update) section.update();
                if (section.render) section.render();
            }
        });
    },

    onScrollLock() {
        console.log('🚀 ~ onScrollLock ~ onScrollLock');
        // if (this.customScroll) this.customScroll.removeFromDom();

        document.body.style.overflow = 'hidden';
    },

    offScrollLock() {
        console.log('🚀 ~ offScrollLock ~ offScrollLock');
        // if (this.customScroll) this.customScroll.addToDom();

        document.body.style.removeProperty('overflow');
    },

    setNeedsResize(val) {
        if (val) this.resize();
    },

    resize() {
        if (this.sections) {
            let accumHeight = 0;

            this.sections.forEach((section) => {
                const top = accumHeight;
                section.resize();
                section.calculateBounds(top);
                accumHeight += section.props.bounds.height;
            });
        }
    },

    onDestroy() {
        gsap.killTweensOf(this.tweens);

        this.sections.forEach((section) => section.destroy());
    },
};

export default PageMixin;
